import React from 'react';
import { oneOfType, arrayOf, node } from 'prop-types';

import SCPageTitle from './styles';

PageTitle.propTypes = {
  children: oneOfType([arrayOf(node), node]).isRequired,
};

function PageTitle({ children }) {
  return <SCPageTitle>{children}</SCPageTitle>;
}

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/PageTitle/PageTitle.js